import axios from "./axios";
import qs from "qs";

export default {
  fetchInvoices(params) {
    return axios.get("/node/fetchInvoices", { params });
  },
  fetchInvoice(params) {
    return axios.get("/node/fetchInvoice", { params });
  },
  addOrUpdateInvoice(data) {
    return axios.post("/node/addOrUpdateInvoice", qs.stringify(data));
  },
  deleteInvoice(data) {
    return axios.post("/node/deleteInvoice", qs.stringify(data));
  },
  voidInvoice(data) {
    return axios.post("/node/voidInvoice", qs.stringify(data));
  },
  confirmInvoice(data) {
    return axios.post("/node/confirmInvoice", qs.stringify(data));
  },
  updateInvoiceFile(data) {
    return axios.post("/node/updateInvoiceFile", qs.stringify(data));
  },
  updateInvoiceStatus(data) {
    return axios.post("/node/updateInvoiceStatus", qs.stringify(data));
  },
  fetchInvoiceStatusCounts(params) {
    return axios.get("/node/fetchInvoiceStatusCounts", { params });
  },
  previewInvoiceFromPayOrders(data) {
    return axios.post("/node/previewInvoiceFromPayOrders", qs.stringify(data));
  },
  createInvoiceFromPayOrders(data) {
    return axios.post("/node/createInvoiceFromPayOrders", qs.stringify(data));
  },
};
